import { Image } from "@shopify/hydrogen";

import { motion } from "framer-motion";
import { SetStateAction } from "react";
import { Dispatch } from "react";

type Props = {
	src: string;
	index: number;
	setActiveSlide: Dispatch<SetStateAction<number | null>>;
};
const InstagramPost = (props: Props) => {
	return (
		<motion.div
			className={`relative w-full cursor-pointer`}
			layoutId={props.src}
			onClick={() => props.setActiveSlide(props.index)}
		>
			<Image
				src={props.src}
				alt="Instagram Image"
				width="100%"
				height="100%"
				className="absolute inset-0 h-full w-full object-cover"
			/>
			<div className="pb-[100%]"></div>
		</motion.div>
	);
};
export default InstagramPost;
